import { createFileRoute } from '@tanstack/react-router'

import { CertificationBadgeLibrary } from '@/components/products/certification-badge-library'

// Sản phẩm › Logo chứng nhận: thư viện logo dùng chung cho ảnh thiết kế sản
// phẩm (không phụ thuộc module bán lẻ).
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/products/certification-badges',
)({
    component: CertificationBadgeLibrary,
})
